export const AFTER_LOGIN_ADM_PATHS = {
  DL_GROUP_LI: "dl-group-li",
  DL_GROUP_EDIT: "dl-group-edit",
  PHOTO_SER_LI: "photo-ser-li",
  PHOTO_SER_EDIT: "photo-ser-edit",
};

export const AFTER_LOGIN_ADM_PATH_VALUES = Object.values(AFTER_LOGIN_ADM_PATHS);
